import axios from "./axios-handler.service";
const BASE_URL = "/api/NotificacoesApple";

export interface NotificacaoApple {
  logNotificacaoApple: LogNotificacaoApple;
  receipt: Receipt;
}

export interface LogNotificacaoApple {
  ambiente: string;
  data: string;
  estadoEntidade?: number;
  idLogNotificacaoApple: string;
  notificacao: string;
  origem: string;
  status: string;
}

export interface Receipt {
  productId: string;
  originalPurchaseDate: string | null;
  expiresDate: string | null;
  originalTransactionId: string;
  transactionId: string;
  purchaseDate: string | null;
  bundleIdentifier?: string;
  appVersion?: string;
  status?: number | null;
  cancellationDate?: string | null;
  cancellationReason?: string;
  isInIntroOfferPeriod?: boolean;
  isTrialPeriod?: boolean;
  originalJSONResponse?: string;
  subscriptionGroupIdentifier?: string;
  quantity?: number | null;
}

export interface UnifiedReceipt {
  environment: string;
  latestReceipt: string;
  latestReceiptInfo: Receipt[];
}

export interface Notification {
  autoRenewProductId: string;
  autoRenewStatus: boolean;
  autoRenewStatusChangeDate: string | null;
  environment: string;
  expirationIntent: string;
  expiresDate: string | null;
  latestExpiredReceipt: string;
  latestExpiredReceiptInfo: Receipt;
  latestReceipt: string;
  latestReceiptInfo: Receipt;
  notificationType: string;
  originalJSONResponse: string;
  unifiedReceipt: UnifiedReceipt;
}

export interface Log {
  logNotificacaoApple: LogNotificacaoApple;
  notification: Notification;
}

export interface FiltrosNotificacoesApple {
  dataInicio: string;
  dataFinal: string;
  offset: number;
  limit: number;
  order?: string;
}

export class NotificacoesAppleService {
  static async lista(filtro: FiltrosNotificacoesApple): Promise<Log[]> {
    const {dataInicio, dataFinal, offset, limit, order} = filtro;
    const response = await axios.get<any>(`${BASE_URL}/Lista`, {
      params: {
        txtDataInicio: dataInicio, 
        txtDataFim: dataFinal, 
        offset, 
        limit, 
        order
      },
    });
    return response.data;
  }
  static async popAssociarNotificacao(id: number): Promise<any> {
    const response = await axios.get<any>(
      `${BASE_URL}/popAssociarNotificacao`,
      {
        params: {
          id,
        },
      }
    );
    return response.data;
  }
  static async AssociarConsultor(
    idLogNotificacaoApple: number | null,
    idConsultor: number | null
  ): Promise<any> {
    const response = await axios.post(`${BASE_URL}/AssociarConsultor`, {
      idLogNotificacaoApple,
      idConsultor,
    });
    return response.data;
  }
}
